<template>
	<div
		v-if="infobarContainer"
		class="infobar-container"
		:class="{
			active: infobarContainer,
			addMargin: !infobarAbout && !infobarTranscript,
			'tabs-active': isAboutOpen || isTranscriptOpen,
		}"
	>
		<div class="infobar-contents">
			<div class="sponsor-content">
				<span v-if="sponsorContent">
					{{ sponsorLabel }}
				</span>
			</div>
			<div
				class="title"
				:class="{ active: infobarTitle }"
			>
				<h3>{{ videoTitle }}</h3>
				<div
					class="info-tabs-close-icon webmd-icon-close"
					@click="toggleAboutTranscript('close')"
				></div>
			</div>
			<div class="about-transcript">
				<button
					v-if="infobarAbout"
					class="about"
					:class="{ active: infobarAbout, open: isAboutOpen }"
					@click="toggleAboutTranscript('about')"
				>
					About
				</button>
				<button
					v-if="infobarTranscript"
					class="transcript"
					:class="{
						active: infobarTranscript,
						open: isTranscriptOpen,
					}"
					@click="toggleAboutTranscript('transcript')"
				>
					<span class="transcript-icon webmd-icon-transcript"></span>
					Transcript
				</button>
				<div
					class="about-video"
					:class="{ 'is-visible': isAboutOpen }"
				>
					<p>
						{{ videoAbout }}
					</p>
					<p
						v-if="videoReviewer"
						class="reviewer"
					>
						Reviewed by {{ videoReviewer }}
					</p>
					<p
						v-if="videoSources"
						class="vid-sources"
					>
						<span v-html="videoSources"></span>
					</p>
					<p class="vid-copyright">
						{{ videoCopyright }}
					</p>
					<div class="vid-disclaimer">
						<p>
							WebMD does not provide medical advice, diagnosis or
							treatment.
						</p>
						<a
							target="_blank"
							href="https://www.webmd.com/about-webmd-policies/additional-info"
						>
							See additional information.
						</a>
					</div>
				</div>
				<div
					class="transcript-video"
					:class="{ 'is-visible': isTranscriptOpen }"
				>
					<div class="transcript-text">
						<p v-html="videoTranscript"></p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Infobar',

	data() {
		return {
			isAboutOpen: false,
			isTranscriptOpen: false,
		};
	},

	props: {
		infobarContainer: {
			type: Boolean,
		},
		infobarTitle: {
			type: Boolean,
		},
		infobarAbout: {
			type: Boolean,
		},
		infobarTranscript: {
			type: Boolean,
		},
		isUserPaused: {
			type: Boolean,
		},
		mode: {
			type: String,
			default: 'in-article',
		},
		moduleName: {
			type: String,
			default: '',
		},
		pageName: {
			type: String,
			default: '',
		},
		sponsorContent: {
			type: Boolean,
		},
		sponsorLabel: {
			type: String,
			default: '',
		},
		videoAbout: {
			type: String,
			default: 'About',
		},
		videoCopyright: {
			type: String,
			default: '',
		},
		videoReviewer: {
			type: String,
			default: '',
		},
		videoSources: {
			type: String,
			default: '',
		},
		videoTitle: {
			type: String,
			default: '',
		},
		videoTranscript: {
			type: String,
			default: 'About',
		},
		vidChron: {
			type: String,
			default: '',
			required: true,
		},
	},

	methods: {
		/**
		 * Accepts module link and fires metrics calls with module name and module link
		 * @param {string} mlink - module link
		 * @param {string} ctl - ctl at the end of module name for player control
		 */
		callAdhoc(mlink, ctl) {
			const link = {
				link: `${this.moduleName}${ctl}_${mlink}`,
			};

			if (this.mode === 'fed') {
				link.pageName = this.pageName;
			}

			this.$vwmdPageLink(link);
		},

		/**
		 * Gets called when about/transcript/close button is clicked
		 * accepts the string value which represents the particlular button
		 * that was clicked
		 */
		toggleAboutTranscript(button) {
			const { playState } = window.vueVideo[this.vidChron].appState;

			if (button === 'about') {
				if (!this.isAboutOpen) {
					// Toggle and close transcript
					if (this.isTranscriptOpen) {
						this.isTranscriptOpen = false;
					}

					// Check if the player is not paused or Ready
					if (playState !== 'pause' && playState !== 'ready') {
						window.vueVideo[this.vidChron].pause();
					}

					// Open about
					this.isAboutOpen = true;
					this.callAdhoc('abtop', '-ctl');
				} else {
					/* eslint-disable no-param-reassign */
					button = 'close';
				}
			} else if (button === 'transcript') {
				if (!this.isTranscriptOpen) {
					// Toggle and close about
					if (this.isAboutOpen) {
						this.isAboutOpen = false;
					}

					// Check if the player is not paused or ready - if not paused then pause it
					if (playState !== 'pause' && playState !== 'ready') {
						window.vueVideo[this.vidChron].pause();
					}

					// Open Transcript
					this.isTranscriptOpen = true;
					this.callAdhoc('trnop', '-ctl');
				} else {
					/* eslint-disable no-param-reassign */
					button = 'close';
				}
			}

			/*
			 * Close Infobar if close button was clicked
			 * or about/transcript was clciked twice consecutively
			 */
			if (button === 'close') {
				// If the video is not ready , already playing and not paused by user then play
				if (playState !== 'ready' && playState !== 'playing' && !this.isUserPaused) {
					window.vueVideo[this.vidChron].play();
				}
				if (this.isAboutOpen) {
					this.callAdhoc('abtcl', '-ctl');
				} else if (this.isTranscriptOpen) {
					this.callAdhoc('trncl', '-ctl');
				}
				this.isAboutOpen = false;
				this.isTranscriptOpen = false;
			}
		},
	},
};
</script>
